// extracted by mini-css-extract-plugin
module.exports = {"prefixlabel":"MemberCard_prefixlabel__8R62k","thailabel":"MemberCard_thailabel__1gdfu"};